import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { translate } from 'react-i18next';
import '../../components/default.css';
import { listAllProject, getProject } from '../../redux/projects/projects_actions';
import SummaryCard from '../../components/summarycard/SummaryCard';
import SavingEnergyConsumptionChart from '../../components/powerconsumptionchart/SavingEnergyConsumptionChart';
import ProjectList from '../../components/projectlist/ProjectList';
import Layout from '../../components/layout/Layout';
import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';

class DashboardPage extends React.Component {
  componentDidMount() {
    this.props.listProject();
  }

  render() {
    const { projects, t } = this.props;
    const breadcrumbItems = [{ name: t('dashboard'), path: '/dashboard' }];

    const summaryItems = [
      {
        title: t('total projects'),
        number: (projects || []).length,
        unit: t('projects'),
        iconClass: 'fas fa-folder fa-3x',
      },
      {
        title: t('total passed projects'),
        number: (projects || []).filter(
          project => project.status === 'Approved',
        ).length,
        unit: t('projects'),
        iconClass: 'fas fa-check fa-3x',
      },
      {
        title: t('total saving energy consumption'),
        number: (projects || []).reduce((sum, {evaluation : { whole_building_energy }}) => sum + whole_building_energy.compliance - whole_building_energy.net_EPA, 0),
        unit: t('kWh/Year'),
        iconClass: 'fas fa-bolt fa-3x',
      },
      {
        title: t('total renewable energy'),
        number: (projects || []).reduce((sum, {evaluation : { whole_building_energy }}) => sum + whole_building_energy.renewable_energy, 0),
        unit: t('kWh/Year'),
        iconClass: 'fas fa-recycle fa-3x',
      },
    ].map(item => ({ ...item, number: getFormatter(FORMATTER_STYLE.decimal)(item.number) }));

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
      >
        <Grid>
          <Row>
            {summaryItems.map((item, index) => (
              <Col xs={12} sm={6} md={3} key={index}>
                <SummaryCard {...item} />
              </Col>
            ))}
          </Row>
          <Row>
            <Col xs={12} sm={12} md={6}>
              <ProjectList projects={projects || []} />
            </Col>
            <Col xs={12} sm={12} md={6}>
              <SavingEnergyConsumptionChart projects={projects || []} />
            </Col>
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.project.orderedIds.map(id => state.project.objects[id]),
  errorMessage: state.project.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listProject: () => dispatch(listAllProject(0, 500)),
  getProject: id => dispatch(getProject(id)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(DashboardPage)
);



// WEBPACK FOOTER //
// ./src/pages/dashboard/DashboardPage.js